import React, { useEffect, useState } from 'react'
import { Grid } from '@material-ui/core';
import { CarouselImagen } from './CarouselImagen';
import { ReunionAfiMed } from './ReunionAfiMed';


export const Teleconsulta = () => {

  const [idAgenda, setIdAgenda] = useState(false);
  const [nombre, setNombre] = useState(false);


  useEffect(() => {

    const params = new URLSearchParams(window.location.search);
    const nombre = params.get('nombre');
    const idAgenda = params.get('idAgenda');
    setNombre(nombre);
    setIdAgenda(idAgenda)
  }, []);


  return (
    <React.Fragment>
      <Grid container direction="row" alignItems="center" spacing={2} style={{ padding: "2rem" }}>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={6}
          //style={{ paddingLeft: "8rem", paddingRight: "8rem" }}
        >
          <ReunionAfiMed nombre={nombre} idAgenda={idAgenda} />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={6}
          style={{ alignSelf: 'center', paddingLeft: 1 }}
        >
          <CarouselImagen />
        </Grid>
      </Grid>

    </React.Fragment>
  )
}
